import type { Location } from 'react-router';

type StoredLocation = Pick<Location, 'pathname' | 'search' | 'hash'>;

type RouteHistoryStore = {
  record: (next: StoredLocation) => void;
  getPrevious: () => StoredLocation | null;
  reset: () => void;
};

const createRouteHistoryStore = (): RouteHistoryStore => {
  let previous: StoredLocation | null = null;
  let current: StoredLocation | null = null;

  return {
    record: (next) => {
      const snapshot: StoredLocation = { pathname: next.pathname, search: next.search, hash: next.hash };
      if (current && current.pathname !== snapshot.pathname) {
        previous = current;
      }
      current = snapshot;
    },
    getPrevious: () => previous,
    reset: () => {
      previous = null;
      current = null;
    },
  };
};

export const routeHistoryStore = createRouteHistoryStore();
